module.exports = __webpack_public_path__ + "static/media/team-2.2451fb86.jpg";